export default __webpack_public_path__ + "static/cover-13-066ec9e3620c1f7227d931ba1f3b217e.jpg";